var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaZyia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / media") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v40-117-&-v40-155",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-53-1",
    transform: "translate(-1400, -449)",
    fill: "#3e2a52",
    stroke: "#3e2a52",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1184, 347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0, 69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-Interaction",
    transform: "translate(168, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-Play",
    transform: "translate(48, 33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,1 C30.3512746,1 36.1012746,3.57436269 40.263456,7.73654403 C44.4256373,11.8987254 47,17.6487254 47,24 C47,30.3512747 44.4256373,36.1012747 40.263456,40.263456 C36.1012746,44.4256373 30.3512746,47 24,47 C17.6487254,47 11.8987254,44.4256373 7.73654404,40.263456 C3.57436269,36.1012747 1,30.3512747 1,24 C1,17.6487254 3.57436269,11.8987254 7.73654404,7.73654403 C11.8987254,3.57436269 17.6487254,1 24,1 Z M21.7578644,13.1345369 C20.9757299,13.0301328 20.1612434,13.1263463 19.4115928,13.4341589 C18.6422313,13.7500649 18.0137442,14.2581654 17.5750194,14.8745004 C17.1196736,15.5141849 16.8670884,16.27077 16.867537,17.062524 L16.8675369,30.1779225 C16.8682665,30.9699389 17.1214552,31.7256804 17.57694,32.3646149 C18.0158146,32.9802493 18.6440247,33.4877249 19.4127687,33.8033774 C20.1618474,34.1109552 20.9756814,34.2073722 21.7573705,34.103514 C22.5464759,33.9986704 23.3015025,33.6899968 23.9267737,33.1961397 L36.0257452,23.6229043 L23.9276931,14.0444673 C23.3027646,13.5495378 22.5474649,13.2399375 21.7578644,13.1345369 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaZyia);
export default __webpack_public_path__ + "static/media/media_Zyia.08465318ed32e095a816ccc6082b925b.svg";
export { ForwardRef as ReactComponent };